import { composeWrappers } from "@redotech/react-util/component";
import { RedoClientProvider } from "@redotech/redo-web/client";
import {
  ExtensionShopifyClient,
  ShopifyAjaxClient,
} from "@redotech/shopify-client/ajax";
import { memo, ReactNode } from "react";
import { ShopifyExtensionClientProvider } from "../client/client-context";
import { RedoShopifyRpcClientContextProvider } from "../client/redo-shopify-rpc-client";
import { ExtensionShopifyClientContext } from "../shopify";

export interface RedoStorefrontOverlayWrapperProps {
  children: ReactNode | ReactNode[];
  extensionShopifyClient?: ExtensionShopifyClient | undefined;
}

export const RedoStorefrontOverlayWrapper = memo(
  function RedoStorefrontOverlayWrapper({
    children,
    extensionShopifyClient,
  }: RedoStorefrontOverlayWrapperProps) {
    return composeWrappers(
      (inner) => (
        <RedoClientProvider
          url={
            globalThis.redoStorefront?.env?.REDO_API_URL ??
            process.env.REDO_API_URL!
          }
        >
          {inner}
        </RedoClientProvider>
      ),
      (inner) => (
        <ShopifyExtensionClientProvider
          storeUrl={
            globalThis.redoStorefront?.storeUrl ?? globalThis.Shopify?.shop
          }
          widgetId={globalThis.redoWidgetId}
        >
          {inner}
        </ShopifyExtensionClientProvider>
      ),
      (inner) => (
        <ExtensionShopifyClientContext.Provider
          value={extensionShopifyClient ?? ShopifyAjaxClient.fromEnv()}
        >
          {inner}
        </ExtensionShopifyClientContext.Provider>
      ),
      (inner) => (
        <RedoShopifyRpcClientContextProvider
          baseUrl={
            globalThis.redoStorefront?.env?.REDO_API_URL ??
            process.env.REDO_API_URL!
          }
          storeUrl={
            globalThis.redoStorefront?.storeUrl ?? globalThis.Shopify?.shop
          }
          widgetId={globalThis.redoWidgetId}
        >
          {inner}
        </RedoShopifyRpcClientContextProvider>
      ),
    )(<>{children}</>);
  },
);
